import React, { useState, useRef } from "react";
import "./First.css";
import { Container } from "react-bootstrap";
import Slider from "react-slick";

// Image Imports
import snappassLogo from "../../../Asset/portfolio/snappass-icon.png";
import forwardBotLogo from "../../../Asset/portfolio/logoforwardbot.png";
import paid from "../../../Asset/portfolio/Paid.svg";
import icon1 from "../../../Asset/portfolio/icon-1.svg";
import icon2 from "../../../Asset/portfolio/icon-2.svg";
import icon3 from "../../../Asset/portfolio/icon-3.svg";
import icon4 from "../../../Asset/portfolio/icon-4.svg";
import mainImg1 from "../../../Asset/portfolio/shiptime-carousle-image-1.png";
import mainImg2 from "../../../Asset/portfolio/Paid-1.webp";
import indiaFlag from "../../../Asset/portfolio/india.svg";
import olapassBanner from "../../../Asset/portfolio/olapassBanner.png";
import forwardBotBanner from "../../../Asset/portfolio/forwardBot_banner (2).png";
import { useNavigate } from "react-router-dom";

const First = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const sliderRef = useRef(null);

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    centerMode: true,
    centerPadding: "0px",
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    beforeChange: (_, next) => setActiveIndex(next),
  };

  const handleSlideChange = (direction) => {
    if (direction === "prev") sliderRef.current.slickPrev();
    if (direction === "next") sliderRef.current.slickNext();
  };

  const navigate = useNavigate();
  const handleNavigate = (title) => {
    navigate("/Portfolio/InnerPortfolio", { state: { title } });
  };

  const renderIndicators = () => (
    <ul className="carousel-indicators">
      {[0, 1].map((index) => (
        <li
          key={index}
          className={activeIndex === index ? "active" : ""}
          onClick={() => {
            sliderRef.current.slickGoTo(index);
            setActiveIndex(index);
          }}
        ></li>
      ))}
    </ul>
  );

  const renderSlide = (slideData) => (
    <div
      className={`carousel-item ${
        activeIndex === slideData.index ? "active" : ""
      }`}
    >
      <div className="row main-row">
        <div className="left-content col-12 col-md-12 col-lg-6 order-1 order-md-1 order-lg-0 pb-4 px-5 px-lg-0 py-lg-5">
          <img src={slideData.logo} className="d-none d-lg-block" alt="logo" />
          <div className="d-flex flex-column">
            <div className="mt-3 mt-sm-3 mt-lg-5 mb-0 order-1 order-lg-0">
              <div className="paid-row">
                {slideData?.industries.map((industry, idx) => (
                  <div className="paid-industry" key={idx}>
                    <p>
                      <b>{industry?.label}</b>
                    </p>
                    <div className="paid-industry-inline mr-4 industry-type">
                      <img
                        src={industry?.icon}
                        alt={industry?.label}
                        className="w-20"
                      />
                      <span className="mb-0 text-second small font-weight-bold">
                        {industry?.text}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <h1 className="title h3 my-0 my-sm-0 my-lg-3 font-weight-bold text-first order-0 order-lg-1">
              {slideData?.title}
            </h1>
          </div>
          <p className="text-second mb-3 mb-lg-5 mt-2">
            {slideData?.description}
          </p>
          <span
            className="redirect-link"
            style={{ cursor: "pointer" }}
            onClick={() => handleNavigate(slideData?.title)}
          >
            View Project
          </span>
        </div>
        <div className="right-content col-12 col-md-12 col-lg-6 order-0 order-md-0 order-lg-1 px-5 px-lg-0">
          <img
            src={slideData?.image}
            alt={slideData?.title}
            className="w-100"
          />
        </div>
      </div>
    </div>
  );

  const slides = [
    {
      index: 0,
      logo: snappassLogo,
      title: "Snappass",
      description:
        "Snappass is a secure and user-friendly event ticketing and digital pass management platform that allows organizers to issue tickets and attendees to browse and manage their events — developed by Codeffi.",
      image: olapassBanner,
      industries: [
        {
          label: "Industry",
          icon: icon1,
          text: "Online Event Ticket Purchase ",
        },
        { label: "Country", icon: indiaFlag, text: "India" },
      ],
    },
    {
      index: 1,
      logo: forwardBotLogo,
      title: "Forward Bot",
      description: "Smart Telegram Message Forwarding Tool",
      image: forwardBotBanner,
      industries: [
        {
          label: "Industry",
          icon: icon4,
          text: "Smart Telegram Message Forwarding Tool",
        },
        { label: "Country", icon: indiaFlag, text: "India" },
      ],
    },
  ];

  return (
    <section className="first-portfolio-section">
      <div className="carousel">
        {renderIndicators()}
        <div className="carousel-inner slider-container">
          <div className="back-color-block"></div>
          <Container>
            <Slider {...settings} ref={sliderRef}>
              {slides.map((slide) => renderSlide(slide))}
            </Slider>
          </Container>
        </div>
        <p
          className="carousel-control-prev"
          onClick={() => handleSlideChange("prev")}
        >
          <span className="carousel-control-prev-icon"></span>
        </p>
        <p
          className="carousel-control-next"
          onClick={() => handleSlideChange("next")}
        >
          <span className="carousel-control-next-icon"></span>
        </p>
      </div>
    </section>
  );
};

export default First;
